import React from "react";
import classes from "./heroSection.module.css";
import { ARTIST_NEXT_DOOR_ARENA } from "../../../utils/images";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleStartCompeting = () => {
    navigate("/artist-next-door-arena/compete");
  };

  const handleVoteNow = () => {
    navigate("/artist-next-door-arena/vote-now");
  };

  return (
    <section className={classes.heroSection}>
      <div className={classes.heroContent}>
        <div className={classes.textContainer}>
          <h1 className={classes.heroTitle}>
            <span className={classes.orange}>AB INDIA</span>
            <span className={classes.white}>KAREGA</span>
            <span className={classes.green}>COMPETE!</span>
          </h1>
          <p className={classes.heroDescription}>
            Where talent meets opportunity, and votes decide the stars. Compete
            in weekly contests, win amazing prizes, and claim your spotlight!
          </p>
          <div className={classes.heroButtons}>
            <button
              className={classes.primaryButton}
              onClick={handleStartCompeting}
            >
              Start Competing
            </button>
            <button className={classes.secondaryButton} onClick={handleVoteNow}>
              Vote Now
            </button>
          </div>
          <div className={classes.statsContainer}>
            <div className={classes.statItem}>
              <span className={classes.statNumber}>5+</span>
              <span className={classes.statLabel}>Categories</span>
            </div>
            <div className={classes.statItem}>
              <span className={classes.statNumber}>₹1L+</span>
              <span className={classes.statLabel}>Bi-Weekly Prizes</span>
            </div>
            <div className={classes.statItem}>
              <span className={classes.statNumber}>10K+</span>
              <span className={classes.statLabel}>Artists</span>
            </div>
          </div>
        </div>
        <div className={classes.imageContainer}>
          <div className={classes.imageWrapper}>
            <div className={classes.imageOverlay}>
              <span className={classes.winnersText}>ARTIST NEXT DOOR</span>
            </div>
            <div className={classes.polaroid}>
              <img
                src={ARTIST_NEXT_DOOR_ARENA}
                alt="Contest Winner"
                className={classes.winnerImage}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={classes.scrollIndicator}>
        <span>Scroll to explore</span>
        <div className={classes.scrollArrow}>↓</div>
      </div>
    </section>
  );
};

export default HeroSection;
